<template lang="pug">
	.project-actions(v-if="Project.SelectedProject")
		.options-button(v-pseudo-modal-show="'project-actions-dropdown'")
			i.icons.cui-options
		div.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'project-actions-dropdown'")
			.dropdown-header.text-center
				strong Project actions
			.dropdown-item(@click="openProjectSettings")
				span Project settings
			.dropdown-item(@click="pullProject" v-if="Project.SelectedProject.type === 'playable' && (User.currentUser.Tags['admin'] || checkGitPull())")
				span Pull from repository
					.icon.fa.fa-spinner.fa-spin(v-if="Monitoring.getChannelState('pull-project-' + Project.SelectedProject.id) !== 'done'")
			//.dropdown-item(@click="rescanProject" v-if="Project.SelectedProject.type === 'playable' && (User.currentUser.Tags['admin'] || checkGitPull())")
				span Rescan project
					.icon.fa.fa-spinner.fa-spin(v-if="Monitoring.getChannelState('rescan-project-' + Project.SelectedProject.id) !== 'done'")
			.dropdown-item(@click="clearProjectAssetsCache" v-if="User.currentUser.Tags['admin'] || checkGitPull()")
				span Clear project assets cache
			.dropdown-item(@click="copyChanges" v-if="Project.SelectedProject.type === 'playable' && false")
				span Copy changes
			.dropdown-item(@click="pasteChanges" v-if="Project.SelectedProject.type === 'playable' && false && checkPasteAvailability() && copyState['paste'] && copyState['title']")
				span Paste changes from
				br
				strong {{copyState['title']}}
			.dropdown-item.blue(@click="moveToPreviousWorkspace" v-if="Project.SelectedProject && getPreviousWorkspace()")
				span Move to {{previousWorkspace.title}} workspace
			.dropdown-item.blue(@click="moveToNextWorkspace" v-if="Project.SelectedProject && getNextWorkspace()")
				span Move to {{nextWorkspace.title}} workspace
			.dropdown-item.blue(@click="moveToArchiveWorkspace" v-if="Project.SelectedProject && !projectTags['workspace-archive']")
				span Move to Archive
			.dropdown-item.green(@click="markAsReleased" v-if="!projectTags['released'] && Project.SelectedProject.type === 'playable' && User.currentUser.Tags['admin']")
				span Load combined js files
			.dropdown-item.red(@click="returnInDevelopment" v-if="projectTags['released'] && Project.SelectedProject.type === 'playable' && User.currentUser.Tags['admin']")
				span Load separated js files
			.dropdown-item.green(@click="showProject" v-if="projectTags['hidden'] && User.currentUser.Tags['admin'] && Project.SelectedProject.type === 'playable'")
				span Show project to client
			.dropdown-item.red(@click="hideProject" v-if="!projectTags['hidden'] && User.currentUser.Tags['admin'] && Project.SelectedProject.type === 'playable'")
				span Hide project from client
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Metadata } 		from './../../services/Metadata';
	import { User } 			from './../../services/User';
	import { Project } 			from './../../services/Project';
	import { Monitoring } 		from './../../services/Monitoring';
	import { Publisher } 		from "./../../services/Publisher";

	export default {
		name: "ProjectActions",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Publishers Changed", "Current User Changed", "Project Changed", "Selected Project Changed", "Pseudo Modal Showed project-actions-dropdown"],
			events: {
				"Monitoring Channel Updated": function() {
					this.update();
				}
			}
		},
		data() {

			this.User = User;
			this.Publisher = Publisher;
			this.Project = Project;
			this.Monitoring = Monitoring;

			this.projectTags = {};
			this.copyState = {
				copy: true,
				paste: false,
				title: null
			};

			this.previousWorkspace = this.getPreviousWorkspace();
			this.nextWorkspace = this.getNextWorkspace();

			return {
				showed: true
			};

		},
		methods: {
			collectData() {

				if (Project.SelectedProject) {

					this.projectTags = _.cloneDeep(Project.SelectedProject.Tags);

				}

				this.previousWorkspace = this.getPreviousWorkspace();
				this.nextWorkspace = this.getNextWorkspace();

			},

			copyChanges() {

				console.log('Copy changes');

				Settings.cloneData = {
					versionId: Version.SelectedVersion.id
				};

				//TODO: почему запрещается копировать заново? если человек передумал или скопировал не то по ошибке?
				this.copyState = {
					copy: false,
					paste: true
				};

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			openProjectSettings() {

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

				Broadcast.call("Show ProjectSettings", []);

			},

			pasteChanges() {

				console.log('Paste changes');

				if (Settings.cloneData && Settings.cloneData.versionId && this.checkPasteAvailability()) {

					throw new Error("Нужно отправить запрос на сервер с информацией откуда и куда скопировать (два id версий проекта) и всё делать там, а не на клиенте.");

				}

				this.copyState = {
					copy: true,
					paste: false
				};

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			checkPasteAvailability() {

				//TODO: нужно проверять возможность вставки настроек по другому а не через title как было раньше
				return (Settings.cloneData && Settings.cloneData.versionId);

			},

			pullProject() {

				if (Monitoring.getChannelState('pull-project-' + Project.SelectedProject.id) === 'done') {

					Server.sendToSocket({
						PullProject: Project.SelectedProject.id
					});

				}

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

				Broadcast.call("Show MonitoringLog", ["pull-project-" + Project.SelectedProject.id]);

			},

			rescanProject() {

				if (Monitoring.getChannelState('rescan-project-' + Project.SelectedProject.id) === 'done') {

					Server.sendToSocket({
						RescanProject: Project.SelectedProject.id
					});

				}

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

				Broadcast.call("Show MonitoringLog", ["rescan-project-" + Project.SelectedProject.id]);

			},

			clearProjectAssetsCache() {

				Server.sendToSocket({
					ClearCompressionCache: Project.SelectedProject.id
				});

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			markAsReleased() {

				Server.sendToSocket({
					MarkAsReleased: Project.SelectedProject.id
				});

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			returnInDevelopment() {

				Server.sendToSocket({
					UnmarkAsReleased: Project.SelectedProject.id
				});

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			getPreviousWorkspace() {

				if (Layout.workspace === 'testing') return Metadata.WorkspacesByCodename['development'];
				if (Layout.workspace === 'production') return Metadata.WorkspacesByCodename['testing'];
				if (Layout.workspace === 'archive') return Metadata.WorkspacesByCodename['testing'];

				return '';

			},

			getNextWorkspace() {

				if (Layout.workspace === 'development') return Metadata.WorkspacesByCodename['testing'];
				if (Layout.workspace === 'testing') return Metadata.WorkspacesByCodename['production'];
				if (Layout.workspace === 'archive') return Metadata.WorkspacesByCodename['production'];

				return '';

			},

			moveToPreviousWorkspace() {

				Server.sendToSocket({
					MoveProjectToWorkspace: {
						projectId: Project.SelectedProject.id,
						workspace: this.getPreviousWorkspace().codename
					}
				});

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			moveToNextWorkspace() {

				Server.sendToSocket({
					MoveProjectToWorkspace: {
						projectId: Project.SelectedProject.id,
						workspace: this.getNextWorkspace().codename
					}
				});

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			moveToArchiveWorkspace() {

				Server.sendToSocket({
					MoveProjectToWorkspace: {
						projectId: Project.SelectedProject.id,
						workspace: 'archive'
					}
				});

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			showProject() {

				Server.sendToSocket({
					UnmarkAsHidden: Project.SelectedProject.id
				});

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			hideProject() {

				Server.sendToSocket({
					MarkAsHidden: Project.SelectedProject.id
				});

				Broadcast.call("Pseudo Modal Hide", ['project-actions-dropdown']);

			},

			checkGitPull() {
				return (Publisher && Publisher.SelectedPublisher && Publisher.SelectedPublisher.options && Publisher.SelectedPublisher.options['GitPull']);
			}
		}
	}
</script>


<style lang="sass" scoped>

	.options-button
		position: absolute
		top: 5px
		height: 45px
		right: 0
		padding: 0.75rem 1rem
		cursor: pointer
		color: #e4e7ea

	.dropdown-menu
		right: -230px
		width: 245px
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

		.dropdown-item.green
			color: #4dbd74

		.dropdown-item.green:hover
			background-color: #4dbd74
			color: #e4e7ea

		.dropdown-item.red
			color: #f86c6b

		.dropdown-item.red:hover
			background-color: #f86c6b
			color: #e4e7ea

		.dropdown-item.blue
			color: #4799eb

		.dropdown-item.blue:hover
			background-color: #4799eb
			color: #e4e7ea

		.dropdown-item.disabled
			color: #73818f

		.icon
			margin-left: 6px

</style>

